import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const RightArrowIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={{ height: '24px', width: '24px', ...sx }} {...props}>
      <path
        d="M9 18L15 12L9 6"
        stroke="#939393"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'transparent'}
      />
    </SvgIcon>
  );
};

export default RightArrowIcon;
